import { NavLink, useNavigate } from "react-router-dom";
import { clearTokens, getToken } from "../services/auth";
import { useState, useEffect } from "react";
import "./Sidebar.css";

const menuItems = [
  { section: "Principal" },
  { path: "/", label: "Dashboard", icon: "layout-dashboard" },
  { section: "Cadastros" },
  { path: "/clientes", label: "Clientes", icon: "users" },
  { path: "/produtos", label: "Produtos", icon: "package" },
  { path: "/funcionarios", label: "Funcionarios", icon: "users-group" },
  { section: "Comercial" },
  { path: "/vendas", label: "Vendas", icon: "shopping-cart" },
  { path: "/servicos", label: "Servicos", icon: "tools" },
  { path: "/compras", label: "Compras", icon: "truck" },
  { section: "Gestao" },
  { path: "/financeiro", label: "Financeiro", icon: "currency-dollar" },
  { path: "/configuracoes", label: "Configuracoes", icon: "settings" },
];

export default function Sidebar() {
  const navigate = useNavigate();
  const [usuario, setUsuario] = useState({nome:"", iniciais:""});
  useEffect(()=>{
    const token = getToken();
    if(!token) return;
    fetch((process.env.REACT_APP_API_URL || "http://localhost:8000/api") + "/auth/me/", {headers:{Authorization:"Bearer "+token}})
      .then(r=>r.json())
      .then(d=>{
        const nome = d.first_name ? d.first_name+" "+(d.last_name||"") : d.username || "Usuario";
        const iniciais = nome.trim().split(" ").map(p=>p[0]).slice(0,2).join("").toUpperCase();
        setUsuario({nome:nome.trim(), iniciais});
      }).catch(()=>{});
  },[]);
  const sair = () => { clearTokens(); navigate("/login"); };
  return (
    <aside className="sidebar">
      <div className="sidebar-logo">
        <img src="/logo.svg" alt="Zephir" style={{height:36,width:"auto",objectFit:"contain"}}/>
      </div>
      <nav className="sidebar-nav">
        {menuItems.map((item, i) =>
          item.section ? (
            <div key={i} className="nav-section-label">{item.section}</div>
          ) : (
            <NavLink
              key={item.path}
              to={item.path}
              end={item.path === "/"}
              className={({ isActive }) => "nav-item" + (isActive ? " active" : "")}
            >
              <i className={`ti ti-${item.icon}`} aria-hidden="true" />
              <span>{item.label}</span>
            </NavLink>
          )
        )}
      </nav>
      <div className="sidebar-footer">
        <div className="user-row" onClick={sair} title="Sair">
          <div className="user-avatar">{usuario.iniciais||"?"}</div>
          <div>
            <div className="user-name">{usuario.nome||"Usuario"}</div>
            <div className="user-role">Clique para sair</div>
          </div>
          <i className="ti ti-logout" style={{marginLeft:"auto",fontSize:16,color:"rgba(255,255,255,0.4)"}}/>
        </div>
      </div>
    </aside>
  );
}






















